import { Component, OnInit } from '@angular/core';

import { MyFavoritesService } from './my-favorites.service';
import { Vessel, Port, Carrier } from '../../shared/models';

@Component({
  selector: 'my-favorites',
  template: require('./my-favorites.component.html'),
  styles: [require('./my-favorites.component.scss')],
  providers: [MyFavoritesService]
})
export class MyFavoritesComponent implements OnInit {
  vessels: Array<Vessel> = new Array<Vessel>();
  ports: Array<Port> = new Array<Port>();
  carriers: Array<Carrier> = new Array<Carrier>();
  routes: Array<any> = new Array<any>();

  startDate: string = '';
  endDate: string = '';

  constructor(private service: MyFavoritesService) {
  }

  ngOnInit() {
    this.startDate = this.service.getStartDate();
    this.endDate = this.service.getEndDate();

    this.carriers = this.service.getCarriers();
    this.ports = this.service.getPorts();
    this.vessels = this.service.getVessels();
    this.routes = this.service.getRoutes();
  }

  hasFavorites(): boolean {
    return this.carriers.length > 0 || this.ports.length > 0 || this.vessels.length > 0 || this.routes.length > 0;
  }

  unfavoriteRoute(originId: number, destinationId: number) {
    this.service.callUnFavoriteRoute(originId, destinationId).then((result) => {
      this.removeRoute(originId, destinationId);
    });
  }

  removeRoute(originId: number, destinationId: number) {
    for (let current = 0; current < this.routes.length; current ++) {
      if (this.routes[current].originId === originId && this.routes[current].destinationId === destinationId) {
        this.routes.splice(current, 1);
      }
    }

    this.service.app.routes = this.routes;
    localStorage.setItem('favoriteRoutes', JSON.stringify(this.routes));
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/my-favorites/my-favorites.component.ts